module.exports = __webpack_public_path__ + "assets/img/00047.f09dad53.png";